import { Controller } from "@hotwired/stimulus"
import { pluralize } from "../util"

export default class extends Controller {
  static values = { finishDate: String }

  connect() {
    this.startTimer()
  }

  startTimer() {
    const finishDate = new Date(this.finishDateValue)
    const localFinishDate = new Date(finishDate.getTime())

    this.updateCountdown(localFinishDate)
    this.timerInterval = setInterval(() => this.updateCountdown(localFinishDate), 1000)
  }

  updateCountdown(finishDate) {
    const now = new Date()
    const distance = finishDate - now

    if (distance <= 0) {
      clearInterval(this.timerInterval)
      this.element.textContent = "00:00:00"
      return
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24))
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((distance % (1000 * 60)) / 1000)

    const formattedHours = String(hours).padStart(2, "0")
    const formattedMinutes = String(minutes).padStart(2, "0")
    const formattedSeconds = String(seconds).padStart(2, "0")

    let daysText = ""

    if (days > 0) {
      daysText = `${pluralize(days, "DAY", "DAYS")} `
    }

    this.element.textContent = `${daysText}${formattedHours}:${formattedMinutes}:${formattedSeconds}`
  }
}
